import clsx from 'clsx'
import Trans from 'next-translate/Trans'
import useTranslation from 'next-translate/useTranslation'
import { Fragment, useEffect, useState } from 'react'

import { HelpCenterArticleProps } from './ts'

function HelpCenterArticle({
  title,
  sections,
  output,
}: HelpCenterArticleProps) {
  const { t } = useTranslation(output)

  const [sectionIndex, setSectionIndex] = useState(-1)

  function parseHash() {
    if (process.browser) {
      const hash = parseInt(window.location.hash.split('-')[1])
      setSectionIndex(hash)
    }
  }

  useEffect(() => {
    if (process.browser) {
      parseHash()
      window.addEventListener('hashchange', parseHash)
      return () => {
        window.removeEventListener('hashchange', parseHash)
      }
    }
  }, [])

  return (
    <article className="grid gap-10">
      <h2 className="text-xl font-medium">{t(title)}</h2>
      <div className="grid gap-12">
        {sections.map(({ title, i18nKey, hrefs }, index) => {
          return (
            <section id={`section-${index}`} key={title} className="grid gap-4">
              <a
                href={`#section-${index}`}
                className={clsx('font-medium cursor-pointer', {
                  'text-violet-150': index === sectionIndex,
                })}
              >
                {t(title)}
              </a>
              <Trans
                i18nKey={output + ':' + i18nKey}
                components={[
                  <Paragraph key={0} />,
                  <Fragment key={1}>
                    <br />
                    <br />
                  </Fragment>,
                  <br key={2} />,
                  <span key={3} className="underline text-violet-150" />,
                  ...hrefs.map((href, index) => (
                    <a
                      key={4 + index}
                      href={href}
                      className="underline text-violet-150"
                    />
                  )),
                ]}
              />
            </section>
          )
        })}
      </div>
    </article>
  )
}

export default HelpCenterArticle

const Paragraph = (props: any) => <div className="text-sm" {...props} />
